const LISTE_FACTURE_ACHAT = {
  title: 'Liste des factures d\'achat',
  breadcrumb: {
    liste: 'Liste factures d\'achat',
  },
  tab: {
    code: 'Facture n°',
    date: 'Date',
    fournisseur: 'Fournisseur(s)',
    etat: 'Etat',
    montantHt: 'Montant HT',
    montantTtc: 'Montant TTC',
    montantPaye: 'Montant payé',
    aRapprocher: 'A rapprocher',
    sousType: 'Type',
  },
  filtre: {
    agence: 'Agence',
    fournisseur: 'Fournisseur(s)',
    codeBail: 'Code bail',
    etat: 'Etat(s)',
    periode: 'Date de facture',
    echeanceBail: 'Bail: {codeBail} ',
    echeanceBailleur: 'Bailleur: {bailleur} ',
    echeancePeriode: 'Echéance du {dateDebut} au {dateFin} ',
    error: {
      date: 'La date de début est plus grande que la date de fin',
    },
  },
};

export default LISTE_FACTURE_ACHAT;
